import React, { useState, useEffect } from "react";
import PropTypes from 'prop-types';
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  FormGroup,
  Input,
  Form,
  FormFeedback,
  InputGroup,
  Button,
} from "reactstrap";
import { useFormik } from "formik"
import * as Yup from "yup"

//i18n
import { withTranslation } from "react-i18next";
// Redux
import { connect } from "react-redux";
import withRouter from "components/Common/withRouter";

// users
import user1 from "../../../assets/images/users/profilepic.png";
import { routes } from "routes/path";
import useApi from "common/ApiMiddlewere";
import toast from "react-hot-toast";
import DeleteModel from "common/deleteModel/deleteModel";
import { Link } from "react-router-dom";

const ProfileMenu = props => {
  // Declare a new state variable, which we'll call "menu"
  const [menu, setMenu] = useState(false);
  const [username, setusername] = useState(JSON.parse(localStorage.getItem("authUser"))?.UserName);
  const [modal, setModal] = useState(false)
  const [changePasswordLoading, setChangePasswordLoading] = useState(false)
  const [isMobile, setisMobile] = useState(window.innerWidth < 768)
  const [passwordShow, setPasswordShow] = useState(false)
  const [screenLoad, setScreenLoad] = useState(false)

  const { getApi, postApi, putApi } = useApi()

  useEffect(() => {
    if (JSON.parse(localStorage.getItem("authUser"))?.FromAttendanceUser == true) {
      setusername(JSON.parse(localStorage.getItem("authUser"))?.UserName)
    } else {
      setScreenLoad(true)
      getApi(`User/user-details?id=${JSON.parse(localStorage.getItem("authUser"))?.Id}`).then(({ data, status }) => {
        setScreenLoad(false)
        if (status === 200) {
          setusername(data?.Username)
        } else {
          toast.error(data, {
            style: {
              fontSize: "15px",
            },
          })
        }
      })
    }

  }, [location.pathname == "/dashboard", location.pathname == "/attendance-log"])

  useEffect(() => {
    if (localStorage.getItem("authUser")) {
      if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
        const obj = JSON.parse(localStorage.getItem("authUser"));
        setusername(obj.displayName);
      } else if (
        process.env.REACT_APP_DEFAULTAUTH === "fake" ||
        process.env.REACT_APP_DEFAULTAUTH === "jwt"
      ) {
        const obj = JSON.parse(localStorage.getItem("authUser"));
        setusername(obj.username);
      }
    }
  }, [props.success]);

  const handleSyncAttendance = () => {
    setScreenLoad(true)
    getApi('Attendance/sync-employee-attendance').then(({ data, status }) => {
      if (status === 200) {
        setScreenLoad(false)
      } else {
        setScreenLoad(false)
        toast.error(data, {
          style: {
            fontSize: "15px",
          },
        })
      }
    })
  }

  useEffect(() => {
    handleSyncAttendance()
  }, [location.pathname == "/employee-leave", location.pathname == "/employee-salary", location.pathname == "/attendance-log", location.pathname == "/advance-log", location.pathname == '/attendance-report' || location.pathname == '/daily-report'])

  const handleChangePassword = () => {
    setModal(!modal)
    validation.handleReset()
  }

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      NewPassword: "",
      ConfirmPassword: "",
    },
    validationSchema: Yup.object({
      NewPassword: Yup.string().required("The new password is required"),
      ConfirmPassword: Yup.string()
        .required("The confirm password is required")
        .oneOf([Yup.ref("NewPassword")], "Passwords must match"),
    }),
    onSubmit: values => {
      if (values) {
        setChangePasswordLoading(true)
        DeleteModel.confirmDeleteInquiry({
          title: "Are you sure? ",
          text: "You want to update password ? ",
          isMobile,
        }).then(response => {
          if (response == true) {
            const endPoint = "User/update-password"
            const obj = {
              userId: 1,
              newPassword: values.ConfirmPassword,
            }
            putApi(endPoint, obj).then(({ data, status }) => {
              if (status == 200) {
                toast.success("successfully updated", {
                  style: {
                    fontSize: "15px",
                  },
                })
                setModal(false)
              } else {
                toast.error(data, {
                  style: {
                    fontSize: "15px",
                  },
                })
              }
              setChangePasswordLoading(false)
            })
          } else {
            setModal(true)
            setChangePasswordLoading(false)
          }
        })
      }
    },
  })

  return (
    <React.Fragment>
      <div>
        {screenLoad && (
          <div className="loading-overlay is-active">
            <span className="fas fa-spinner fa-3x fa-spin"></span>
          </div>
        )}
        <div style={{ gap: "15px", display: "flex" }}>
          {JSON.parse(localStorage.getItem("authUser"))?.Id == 1 && (
            <div className="d-flex align-items-center justify-content-center">
              <Button
                user="primary"
                className="btn btn-primary btn-sm "
                type="button"
                color="primary"
                onClick={() => handleSyncAttendance()}
              >
                Sync Attendance
              </Button>
            </div>

          )}
          <Dropdown
            isOpen={menu}
            toggle={() => setMenu(!menu)}
            className="d-inline-block"
          >
            <DropdownToggle
              className="btn header-item "
              id="page-header-user-dropdown"
              tag="button"
            >
              <img
                className="rounded-circle header-profile-user"
                src={user1}
                alt="Header Avatar"
              />
              <span className="d-none d-xl-inline-block ms-2 me-1">{JSON.parse(localStorage.getItem("authUser"))?.FromAttendanceUser == true ? JSON.parse(localStorage.getItem("authUser"))?.UserName : username}</span>
              <i className="mdi mdi-chevron-down d-none d-xl-inline-block" />
            </DropdownToggle>
            <DropdownMenu className="dropdown-menu-end">
              {JSON.parse(localStorage.getItem("authUser"))?.RoleName == "Admin" && (
                <div>
                  <div style={{ color: "black" }} onClick={handleChangePassword}>
                    <DropdownItem>
                      <i className="bx bx-lock-open font-size-16 align-middle me-1" />
                      {"Change Password"}
                    </DropdownItem>
                  </div>

                </div>
              )}
              <Link to="/logout" className="dropdown-item">
                <i className="bx bx-power-off font-size-16 align-middle me-1 text-danger" />
                <span>{props.t("Logout")}</span>
              </Link>
            </DropdownMenu>
          </Dropdown>
        </div>
      </div>
      <Modal
        isOpen={modal}
        toggle={() => setModal(!modal)}
        centered={true}
        size="small"
        style={{ width: !isMobile ? "350px" : "" }}
      >
        <div className="modal-content">
          <ModalHeader toggle={() => setModal(!modal)} tag="h5">
            {"Change Password"}
          </ModalHeader>
          <ModalBody>
            <Form
              onSubmit={e => {
                e.preventDefault()
                validation.handleSubmit()
                return false
              }}
              onReset={e => {
                e.preventDefault
                validation.handleReset()
                return false
              }}
            >

              <FormGroup className="mb-2">
                <Label htmlFor="validationCustom03" className="required">
                  New Password
                </Label>
                <Input
                  name="NewPassword"
                  placeholder="New Password"
                  type="password"
                  className="form-control-sm"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.NewPassword || ""}
                  invalid={
                    validation.touched.NewPassword &&
                      validation.errors.NewPassword
                      ? true
                      : false
                  }
                />
                {validation.touched.NewPassword &&
                  validation.errors.NewPassword ? (
                  <FormFeedback type="invalid">
                    {validation.errors.NewPassword}
                  </FormFeedback>
                ) : null}
              </FormGroup>
              <Label htmlFor="validationCustom03" className="required">
                Confirm Password
              </Label>
              <InputGroup className="mb-2">
                <Input
                  className="form-control-sm"
                  name="ConfirmPassword"
                  value={validation.values.ConfirmPassword || ""}
                  type={passwordShow ? "text" : "password"}
                  placeholder="Confirm Password"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  invalid={
                    validation.touched.ConfirmPassword &&
                    !!validation.errors.ConfirmPassword
                  }
                />
                <Button
                  onClick={() => setPasswordShow(!passwordShow)}
                  className="btn btn-sm"
                  style={{ border: "1px solid #ced4da" }}
                  color="light"
                >
                  {passwordShow ? (
                    <i className="mdi  mdi-eye-off-outline" />
                  ) : (
                    <i className="mdi mdi-eye-outline" />
                  )}
                </Button>
                {validation.touched.ConfirmPassword &&
                  validation.errors.ConfirmPassword ? (
                  <FormFeedback type="invalid">
                    {validation.errors.ConfirmPassword}
                  </FormFeedback>
                ) : null}
              </InputGroup>

              <div className="text-end">
                <>
                  {changePasswordLoading ? (
                    <button
                      type="button"
                      className="btn btn-primary btn-sm"
                    >
                      <i className="bx bx-hourglass bx-spin font-size-16 align-middle me-2"></i>
                      Loading
                    </button>
                  ) : (
                    <Button
                      color="primary"
                      className="btn btn-primary btn-sm "
                      type="submit"
                    >
                      Submit
                    </Button>
                  )}
                </>
              </div>
            </Form>
          </ModalBody>
        </div>
      </Modal>

    </React.Fragment>
  );
};

ProfileMenu.propTypes = {
  success: PropTypes.any,
  t: PropTypes.any
};

const mapStatetoProps = state => {
  const { error, success } = state.Profile;
  return { error, success };
};

export default withRouter(
  connect(mapStatetoProps, {})(withTranslation()(ProfileMenu))
);
